export const Main = () => {
    return (
        <div className="main">
            <p>Тут будет главная</p>
        </div>
    )
}